import { ApiVersions } from 'src/app/shared/services/api-version';
import { Injectable } from '@angular/core';
import { CustomDocumentService } from 'src/app/shared/services/custom-document.service';

@Injectable({
  providedIn: 'root'
})
export class PortalCustomDocumentService extends CustomDocumentService {
  constructor() {
    super();
  }

  public getProfileDocumentUploadPath(entityId: string, attributeDefinitionId: string) {
    return {
      path: `portal/profile/custom-fields/${attributeDefinitionId}/custom-document`,
      apiVersion: ApiVersions.unversioned
    };
  }

  public getProfileDocumentDeletePath(
    path: string,
    fileName: string,
    tenantId: string,
    entityId: string
  ) {
    return path
      .replace('portal/profile/custom-fields', `${tenantId}/person-documents/${entityId}`)
      .replace('custom-document', fileName);
  }
}
